import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiProjects = () => {
 const { auth } = contextApp();

 const ProjectApi = axios.create({
  baseURL: urls.projects(),
  headers: { 'x-access-token': auth?.token }
 });

 const paramsDefault = { items: null, product: 'terrains' };

 const createProject = async project => (await ProjectApi.post('/', project)).data;

 const getProjectsByCompany = async () => (await ProjectApi.get('/')).data;

 const getProjects = async () => (await ProjectApi.get('/')).data;

 const getProjectsNames = async () => (await ProjectApi.get('/', { params: { names: true } })).data;

 const getProject = async id => (await ProjectApi.get('/' + id)).data;

 const getTerrainsByProject = async id => (await projectApi.get('/terrains/' + id)).data;

 const getTerrains = async (id, params = paramsDefault) => (await projectApi.get('/' + id, { params })).data;

 return { createProject, getProjects, getProjectsByCompany, getTerrainsByProject, getTerrains, getProject, getProjectsNames };
};

const token = JSON.parse(localStorage.getItem('sesion'))?.token || null;
const projectApi = axios.create({
 baseURL: urls.project,
 headers: { 'x-access-token': token }
});

/* *****************getProject*************** */
export const getProject = async id => {
 /* urls.project({ symbol, page, size }) */
 const url = `${urls.project}/${id}`;
 const headers = { 'x-access-token': token };
 const settings = await axios.get(url, { headers });
 return settings.data; // { count, rows }
};
/* El código anterior es una función llamada "getProject" que se utiliza para obtener información sobre un proyecto específico desde una API. La función es una función asíncrona que retorna una promesa.
La función toma un parámetro "id", que es el identificador único del proyecto que se quiere recuperar.
En la primera línea, se construye la URL que se utilizará para hacer la petición a la API. Esto se logra utilizando la función urls.project y pasando como parámetro el identificador del proyecto. La URL resultante será utilizada para hacer una petición GET a la API.
En la siguiente línea, se crea un objeto "headers" que contiene el token de acceso necesario para autorizar la petición a la API.
A continuación, se utiliza la función axios.get para realizar una petición GET a la API con la URL y los encabezados proporcionados. La respuesta a la petición se almacena en la variable "settings".
Finalmente, se devuelve el valor de "settings.data". Este valor es un objeto que contiene información sobre el proyecto que se ha recuperado desde la API. */

/* ***************getProjects**************** */
export const getProjects = async business => {
 const url = urls.project([business]);
 const headers = { 'x-access-token': token };
 const settings = await axios.get(url, { headers });
 return settings.data; // { count, rows }
}; /* 
Este es un módulo que exporta una función llamada getProjects. La función recibe tres argumentos: business, page y size.
La función hace una petición GET a una URL específica, la cual se construye con la función urls.project que recibe el argumento business. Luego, la función agrega un header a la petición con una clave 'x-access-token' y el valor token.
La petición se realiza con la librería axios y se almacena en la variable settings. Luego, se retorna el valor de settings.data, que se espera que sea un objeto con dos claves count y rows.
EN RESUMEN getProjects obtiene una lista de proyectos. Para esto, utiliza la función urls.project que recibe un arreglo con el nombre de la empresa. La URL generada por esta función es enviada a la API utilizando la librería axios de la misma forma que la función anterior. La respuesta de la API es devuelta a través del objeto settings.data que contiene la información de una lista de proyectos. */

/* **********************getTerrainsByProject***************** */
export const getTerrainsByProject = async id => {
 const url = `${urls.project}/${'terrains'}/${id}`;
 const settings = await projectApi.get(url);
 return settings.data; // { count, rows }
}; /*  La función es asíncrona y recibe como parámetro un ID.
La función hace uso de una llamada a la API de proyectos, que es una llamada HTTP a un servidor remoto. Se llama a la API con el método "get" y se le pasa una ruta de "/terrains/ + id", donde "id" es el ID proporcionado como parámetro.
La respuesta de la API se almacena en la variable "settings" y luego se devuelve el valor "data" de "settings". Este valor es un objeto con dos propiedades: "count" y "rows".
En resumen, esta función se conecta a la API de proyectos y solicita los terrenos asociados con un proyecto específico a partir de su ID. Luego, devuelve los datos de los terrenos en un objeto con dos propiedades: el número total de terrenos y los datos de los terrenos en sí. */

/* ***************getTerrainsByIds************** */
export const getTerrainsByIds = async (ids = [1, 2, 3]) => {
 const params = { params: { ids } };
 const settings = await projectApi.get('/terrains', params);
 return settings.data;
}; /* Este código es una función en JavaScript que utiliza la sintaxis de una función asíncrona (async) para hacer una solicitud HTTP a una API.
La función getTerrainsByIds recibe un argumento ids.
Luego, se define un objeto params con una propiedad params que contiene un objeto con una propiedad ids con un arreglo de números [1, 2, 3].
Se imprime en la consola el objeto params.
Se hace una solicitud HTTP GET a la ruta "/terrains" en projectApi con los parámetros params y se guarda la respuesta en una variable settings.
Finalmente, se devuelve el valor de la propiedad data del objeto settings. */

export const updateCompany = async (token, newData, id) => {
 const url = urls.person(id);
 const headers = { 'x-access-token': token };
 const settings = await axios.patch(url, newData, { headers });
 return settings.data;
};

export const registerCompany = async newCompany => {
 const url = urls.company + '/register';
 const headers = { 'x-access-token': token };
 const settings = await axios.post(url, newCompany, { headers });
 return settings.data;
};

export const deletCompany = async (symbol, orderId, token) => {
 const url = urls.order({ symbol, orderId });
 const headers = { 'x-access-token': token };
 const settings = await axios.delete(url, { headers });
 return settings.data; // { count, rows }
};

export const syncCompany = async (beholderOrderId, token, data = []) => {
 const url = urls.order({ sync: true, beholderOrderId });
 const headers = { 'x-access-token': token };
 const settings = await axios.post(url, data, { headers });
 return settings.data; // { count, rows }
};

export default {
 getProject,
 getProjects,
 updateCompany,
 deletCompany,
 syncCompany,
 getTerrainsByProject
};

/* 
**************************DESCRIPCION GENERAL******************************


Este archivo es un módulo de API que contiene una serie de funciones para realizar diferentes operaciones de API, como consultar una compañía, obtener proyectos, crear proyectos, actualizar compañías, registrar compañías, eliminar compañías y sincronizar compañías.

En la parte superior se importa el módulo axios para hacer solicitudes HTTP y también se importa un archivo de configuración que contiene las URL necesarias para realizar las solicitudes.

Luego, se crea un token que se utilizará en las solicitudes HTTP para autenticación. El token se obtiene de la memoria local del navegador o, en su defecto, se establece en null. También se crea un objeto de API de proyecto utilizando axios con la URL base y el encabezado que incluye el token.

Luego, hay diferentes funciones exportadas que realizan diferentes operaciones de API. Cada función utiliza axios para realizar una solicitud HTTP y devuelve los datos devueltos por la API.

Por ejemplo, la función consultCompanyByNit toma un NIT como entrada y realiza una solicitud POST a la API con ese NIT y el token en el encabezado. La función getProjects toma los argumentos de negocios, página y tamaño y realiza una solicitud GET a la API con el token en el encabezado.

En general, todas las funciones funcionan de manera similar, realizando una solicitud HTTP a la API con el token en el encabezado y devolviendo los datos devueltos por la API.

Por último, se exporta un objeto por defecto que contiene solo algunas de las funciones exportadas, como getProject, getProjects, updateCompany, createProject, deletCompany y syncCompany. */
